/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="height: 30px;"></div>
    <!-- 搜索筛选 -->
    <!-- <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form> -->
    <div v-for="(item, index) in listData" :key="index">
      <el-descriptions title="订单信息" border>
        <el-descriptions-item label="id">{{item.supplierSubOrderNo}}</el-descriptions-item>
        <el-descriptions-item label="商品名">{{item.spuName}}</el-descriptions-item>
        <el-descriptions-item label="规格">{{item.skuSpecDesc}}</el-descriptions-item>
        <el-descriptions-item label="订单金额">{{item.skuActPrice}}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{item.skuPrice}}</el-descriptions-item>
        <el-descriptions-item label="供货价格">{{item.itemPrice}}</el-descriptions-item>
        <el-descriptions-item label="快递公司">{{item.logisticsCompany}}</el-descriptions-item>
        <el-descriptions-item label="物流单号">{{item.logisticsCode}}</el-descriptions-item>
        <el-descriptions-item label="快递状态">{{item.logisticsStatusDesc}}</el-descriptions-item>

      </el-descriptions>
      <div v-for="(it, ind) in item.aftersaleVOList" :key="ind" style="margin-top:10px ;margin-left: 20px;">
        <el-descriptions title="售后信息" border>
          <el-descriptions-item label="售后工单号">{{it.workOrderNo}}</el-descriptions-item>
          <el-descriptions-item label="售后类型">{{it.saleAfterType}}</el-descriptions-item>
          <el-descriptions-item label="用户反馈问题描述">{{it.problem_remark}}</el-descriptions-item>
          <el-descriptions-item label="状态">{{it.status}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <!--列表-->

    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    b2cordersupplierSubOrder,
    b2corderlist
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: sessionStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          payerUserid: '',
          supplierOrderNo: this.$route.query.supplierOrderNo,
          orderId: '',
          value1: '',
          type: '-1'
        },
        optionsorderState: '',
        // 删除部门
        seletedata: {
          ids: '',
          token: sessionStorage.getItem('logintoken')
        },
        options: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.orderType()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      orderType() {
        let pro = {}
        b2csupplierlist(pro)
          .then(res => {
            this.options = Object.values(res.data)
            console.log(this.options)
          })
      },
      // 获取公司列表
      getdata(parameter) {
        let pro = {
          "userId": "abcdef",
          "current": 1,
          "size": 1000,
          supplierOrderNo: parameter.supplierOrderNo,
        }
        b2cordersupplierSubOrder(pro)
          .then(res => {
            this.loading = false
            if (res.code == 200) {
              this.listData = res.data.records
              // 分页赋值
              this.pageparm.currentPage = res.data.current
              this.pageparm.pageSize = res.data.size
              this.pageparm.total = res.data.total
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.getdata(this.formInline)
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/b2c/product2.vue